<template>
  <div id="app">
    <!--<div class="m-flexContainer">
      <div class="a-heroImage"></div>

      <div class="m-formContainer">
        <LoginForm :title="headerText" />
        
        
      </div>
    </div>-->
    <IndexPage :title="headerText"/>
    

    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  </div>
</template>

<script>
  
import IndexPage from "./views/IndexPage.vue";
//import IndexPage from "./components/TransferRequestPage.vue";
//import LoginForm from "./components/LoginForm.vue";
//import Inventory from "./components/Inventory.vue";

export default {
  name: "app",
  data() {
    return {
      headerText: "Inventory Web"
    };
  },
  components: {
    IndexPage,    
   //LoginForm
  // Inventory
  }
};
</script>

<style lang="scss">
/* GLOBAL SCSS IMPORT */
@import "./scss/main.scss";

</style>
